import type { CaffeinateMailing } from './caffeinate-mailing.type.ts';
export interface CaffeinateMailingExtension extends CaffeinateMailing {}
export class CaffeinateMailingExtension {
  // Convenience getters for common template values
  get recipientName(): string | undefined {
    return this.templateSubstitutions?.['-recipient_name-'];
  }

  get recipientEmail(): string | undefined {
    return this.templateSubstitutions?.['-to_email-'];
  }

  get companyName(): string | undefined {
    return this.templateSubstitutions?.['-company_name-'];
  }

  get employeeId(): string | undefined {
    return this.templateSubstitutions?.['-employee_id-'];
  }
}

const Registration = {
  kind: 'object',
  name: 'caffeinate-mailing',
  features: CaffeinateMailingExtension,
};
export default Registration;
